import axios from '@/api/axios.config'
import {
  copyAllProductTemplatesSchema,
  createDefaultLayoutsForProductSchema,
  createNewProductSchema,
  duplicateThemeSchema,
  layoutTemplateCopySchema,
  migrateDataSchema,
} from '@messenger/types'
import type { z } from 'zod'

/** A template a bulk admin copy left out, because the Lotus text boxes it
 * holds may not be placed where the copy writes. */
export type SkippedTemplate = { id: string; name: string }

/** What a bulk admin copy answers: the templates it left out. */
export type BulkCopyResponse = { success: boolean; skipped?: SkippedTemplate[] }

export const migrateThemes = async (
  payload: z.infer<typeof migrateDataSchema>,
) => {
  return await axios.post<{ success: boolean }>('/migrateTableData', payload)
}

export const migrateVerses = async () => {
  return await axios.post<{ success: boolean }>('/migrateVerses')
}

export const makeGlobalLayouts = async () => {
  return await axios.post<BulkCopyResponse>('/globalLayouts')
}

export const revertGlobalLayouts = async () => {
  return await axios.post<BulkCopyResponse>('/localLayouts')
}

export const createMissingProductThemeOverrides = async () => {
  return await axios.post<{ success: boolean }>(
    '/createMissingProductThemeOverrides',
  )
}

export const copyLayoutTemplateAllThemes = async (
  payload: z.infer<typeof layoutTemplateCopySchema>,
) => {
  return await axios.post<{ success: boolean }>('/layoutTemplateCopy', payload)
}

export const copyAllProductTemplates = async (
  payload: z.infer<typeof copyAllProductTemplatesSchema>,
) => {
  return await axios.post<BulkCopyResponse>('/copyAllProductTemplates', payload)
}

export const validateMessengerProductsToDpsv2 = async () => {
  return await axios.post<{ success: boolean }>(
    '/validateMessengerProductsToDpsv2',
  )
}

export const createNewProduct = async (
  payload: z.infer<typeof createNewProductSchema>,
) => {
  return await axios.post<{ success: boolean }>('/createNewProduct', payload)
}

export const createDefaultLayoutsForProduct = async (
  payload: z.infer<typeof createDefaultLayoutsForProductSchema>,
) => {
  return await axios.post<{ success: boolean }>(
    '/createDefaultLayoutsForProduct',
    payload,
  )
}

export const duplicateTheme = async (
  payload: z.infer<typeof duplicateThemeSchema>,
) => {
  return await axios.post<BulkCopyResponse>('/duplicateTheme', payload)
}

export const getAdminFuneralHomes = async (search?: string) => {
  return await axios.get<{ id: string; name: string }[]>(
    '/admin/funeralHomes',
    {
      params: search ? { search } : undefined,
    },
  )
}

export const getAdminFuneralHomePageSets = async (
  funeralHomeId: string,
  productId: string,
  themeId: string,
  applicationType: string,
) => {
  return await axios.get('/admin/funeralHomePageSets', {
    params: {
      funeral_home_id: funeralHomeId,
      product_id: productId,
      theme_id: themeId,
      application_type: applicationType,
    },
  })
}
